import type { BaseError as ViemBaseError } from "viem"
import type { BaseError as WagmiBaseError } from "wagmi"
import { walk } from "./walk"

export function isRequestExpiredError(
  error: WagmiBaseError | ViemBaseError,
): boolean {
  return !!walk(error, e => {
    const errorMessage = e instanceof Error ? e.message : JSON.stringify(e)

    if (REQUEST_EXPIRED_REGEX.test(errorMessage)) {
      return true
    }

    return false
  })
}

const REQUEST_EXPIRED_REGEX = /Request expired/gi
